import * as modelsGet from "../models/get";
import { getBurialMethods } from "../api/burialMethods";

var burialMethods: modelsGet.IBurialMethod[];

/**
 * Gibt alle Bestattungsarten zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getBurialMethodsAsync(reload: boolean = false): Promise<modelsGet.IBurialMethod[]>
{
    if (burialMethods == null || reload)
    {
        burialMethods = await getBurialMethods();
    }

    return burialMethods;
}